import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/expenses')({
  staticData: { crumb: 'expenses' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'expenses.read'),
  component: Outlet,
})
